import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="mobile-sidebar"
export default class extends Controller {
  static targets = ["sidebar", "overlay"];

  connect() {
    this.handleScroll = this.handleScroll.bind(this);
    this._scrollIdleTimer = null;
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll);
    if (this._scrollIdleTimer) {
      clearTimeout(this._scrollIdleTimer);
      this._scrollIdleTimer = null;
    }
  }

  handleOutsideClick() {
    this.close();
  }

  open() {
    this.sidebarTarget.classList.remove("hidden");
    this.overlayTarget.classList.remove("hidden");
    this.enter(this.sidebarTarget);
    this.resetIdleTimer();
  }

  close() {
    this.overlayTarget.classList.add("hidden");
    this.leave(this.sidebarTarget).then(() => {
      this.sidebarTarget.classList.add("hidden");
    });
    if (this._scrollIdleTimer) {
      clearTimeout(this._scrollIdleTimer);
      this._scrollIdleTimer = null;
    }
  }

  handleScroll() {
    if (!this.isMobile()) return;
    if (this.sidebarTarget.classList.contains("hidden")) return;
    this.resetIdleTimer();
  }

  resetIdleTimer() {
    if (this._scrollIdleTimer) clearTimeout(this._scrollIdleTimer);
    this._scrollIdleTimer = setTimeout(() => {
      this.close();
    }, 2000);
  }

  enter(element, transitionName = null) {
    this.transition("enter", element, transitionName);
  }

  leave(element, transitionName = null) {
    return this.transition("leave", element, transitionName);
  }

  async transition(direction, element, animation) {
    const dataset = element.dataset;
    const animationClass = animation ? `${animation}-${direction}` : direction;
    const transition = `transition${direction.charAt(0).toUpperCase() + direction.slice(1)}`;
    const genesis = dataset[transition]
      ? dataset[transition].split(" ")
      : [animationClass];
    const start = dataset[`${transition}Start`]
      ? dataset[`${transition}Start`].split(" ")
      : [`${animationClass}-start`];
    const end = dataset[`${transition}End`]
      ? dataset[`${transition}End`].split(" ")
      : [`${animationClass}-end`];

    this.addClasses(element, genesis);
    this.addClasses(element, start);
    await this.nextFrame();
    this.removeClasses(element, start);
    this.addClasses(element, end);
    await this.afterTransition(element);
    this.removeClasses(element, end);
    this.removeClasses(element, genesis);
  }

  addClasses(element, classes) {
    element.classList.add(...classes);
  }

  removeClasses(element, classes) {
    element.classList.remove(...classes);
  }

  nextFrame() {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve);
      });
    });
  }

  afterTransition(element) {
    return new Promise((resolve) => {
      const computedDuration =
        getComputedStyle(element).transitionDuration.split(",")[0];
      const duration = Number(computedDuration.replace("s", "")) * 1000;
      setTimeout(resolve, duration);
    });
  }

  isMobile() {
    return window.innerWidth < 1024;
  }
}
